import React from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

const FilterTag = (props: Props) => {
  const { onClick, children } = props;

  return (
    <Button onClick={onClick}>
      {children}
      <Icon icon={faTimes} size="xs" />
    </Button>
  );
};

const Button = styled.button`
  appearance: none;
  display: inline-block;
  font-size: 14px;
  margin: 0 0.25rem;
  background-color: ${({ theme }) => theme.colors.secondaryLight};
  border: 1px solid ${({ theme }) => theme.colors.secondary};
  color: ${({ theme }) => theme.colors.secondary};
  padding: 2px 0.5rem;
  border-radius: 4px;
  margin-bottom: 0.5rem;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  text-transform: capitalize;
  transition: background-color ease-in-out 180ms;

  :hover,
  :focus {
    background-color: ${({ theme }) => theme.colors.secondaryLightHover};
  }
`;

const Icon = styled(FontAwesomeIcon)`
  margin-left: 0.5rem;
  cursor: pointer;
`;

type Props = {
  onClick: () => void;
  children: React.ReactNode;
};

export default FilterTag;
